import { FeatureFlag, useFeatureFlags } from './useFeatureFlags'

export const useLiveStreamSetup = () => {
  const flags = useFeatureFlags()
  const isCamio = flags[FeatureFlag.camioCameraStream]
  const isOrangePeel = flags[FeatureFlag.orangePeelCameraStream]

  return {
    // Deliberately unaffected by FeatureFlag.lumanaCameraStream: this gates the
    // camera-creation menu items (SideBar / CreateDropdown), which have no
    // Lumana setup flow yet. The Lumana playback gate lives at its consumers,
    // CameraDeviceDrawer and ACDeviceDrawer.
    hasNoLiveStream: !isCamio && !isOrangePeel,
    isCamio,
    isOrangePeel,
  }
}
